import type { ContratProDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import type { LovCproDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import { propertyStatusConfiguration, reglesConfiguration } from '@/features/domaine/regles-akto/CPRO'
import { cproService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandeCPROStore = buildDemandeStore<ContratProDTO, LovCproDTO>({
  dispositif: 'CPRO',
  demandeService: cproService,
  propertyStatusConfiguration,
  reglesConfiguration,
})

